module.exports = __webpack_public_path__ + "apple-touch-icon-120x120.png?2ecdad09273e324b189b95a91c36eebe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-touch-icon-120x120.png
// module id = 139
// module chunks = 0